export const DEFAULT_DB_NAME = 'FrontOfficeDatabase';
export const DEFAULT_DB_VERSION = 6;

export interface IndexDBIndex {
	name: string;
	isUnique: boolean;
}

export interface IndexedDbStore {
	name: string;
	keyPath: any;
	indexDBIndex: IndexDBIndex[];
}

export enum DeepLinkType {
	REGULAR = 'REGULAR',
	NOTIFICATION = 'NOTIFICATION'
}

export const INDEX_DB_STORES: IndexedDbStore[] = [
	{
		name: 'deep-link',
		keyPath: 'linkType',
		indexDBIndex: []
	}
];
